/**
 * Функция проверяет права на доступ и взаимодействие с контентом
 */
import { ISecurableRight } from '../models/types';

const isSatisfied = (requirement: any, rights: ISecurableRight[]) => {
  if (!Array.isArray(rights)) {
    return false;
  }

  const uid = requirement.uid;

  // Prefer exact action match over FullAccess to avoid Deny shadowing Grant
  const exact = rights.find(
    right => right.uid === uid && right.action === requirement.action
  );
  if (exact) return exact.result === 'Grant';

  // Fall back to FullAccess grant on same resource
  const full = rights.find(
    right => right.uid === uid && right.action === 'FullAccess'
  );
  return full?.result === 'Grant';
};

export default isSatisfied;
